var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "users_filter" },
    [
      _c(
        "b-modal",
        {
          attrs: {
            id: "users_filter",
            "no-close-on-backdrop": true,
            "hide-header": true,
            size: "xl",
            bodyClass: "p-0",
            title: "Заміна останнього погоджувача",
          },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function ({ ok, cancel }) {
                return [
                  _vm.show_action
                    ? _c("b-spinner", { attrs: { variant: "success" } })
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      staticClass: "btn btn-lg waves-effect waves-themed mr-3",
                      attrs: { size: "xl", variant: "outline-primary" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.close_filter()
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "fal fa-check mr-1" }),
                      _vm._v("\n                Зберегти\n            "),
                    ]
                  ),
                ]
              },
            },
          ]),
          model: {
            value: _vm.show,
            callback: function ($$v) {
              _vm.show = $$v
            },
            expression: "show",
          },
        },
        [
          _c(
            "div",
            {
              staticClass:
                "panel-hdr border-faded border-top-0 border-right-0 border-left-0 shadow-0",
            },
            [
              _c("h2", [
                _vm._v("\n                Змінити "),
                _c("span", { staticClass: "fw-300" }, [
                  _vm._v("останнього погоджувача"),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "panel-toolbar pr-3 pb-2 align-self-end" },
                [
                  _c(
                    "button",
                    {
                      staticClass:
                        "btn btn-panel bg-transparent fs-xl w-auto h-auto rounded-0 waves-effect waves-themed",
                      on: {
                        click: function ($event) {
                          return _vm.close()
                        },
                      },
                    },
                    [_c("i", { staticClass: "fal fa-times" })]
                  ),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "panel-container show" }, [
            _c(
              "div",
              { staticClass: "panel-content p-2" },
              [
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      { staticClass: "adjusted_list", attrs: { sm: "6" } },
                      [
                        _c(
                          "div",
                          { staticClass: "isp_list" },
                          _vm._l(this.adjust, function (item) {
                            return _c("user_block", {
                              key: item.id,
                              attrs: { show_vacation: true, user: item },
                            })
                          }),
                          1
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("b-col", { attrs: { sm: "6" } }, [
                      _c("div", { staticClass: "search_form" }, [
                        _c(
                          "div",
                          { staticClass: "search_filed" },
                          [
                            _c(
                              "b-input-group",
                              [
                                _c(
                                  "b-input-group-text",
                                  {
                                    attrs: { slot: "prepend" },
                                    slot: "prepend",
                                  },
                                  [_vm._v("по ПІБ, посада")]
                                ),
                                _vm._v(" "),
                                _c("b-form-input", {
                                  model: {
                                    value: _vm.search,
                                    callback: function ($$v) {
                                      _vm.search = $$v
                                    },
                                    expression: "search",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "users_list pt-3 ml-0 pl-0" },
                              [
                                _c(
                                  "ul",
                                  {
                                    staticClass:
                                      "user_list_to_insert ml-0 pl-0",
                                  },
                                  _vm._l(_vm.searched, function (item) {
                                    return _c("li", [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "user_profile position-relative border mb-2",
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex flex-row pt-2 pl-2 pb-2",
                                            },
                                            [
                                              _c(
                                                "span",
                                                { staticClass: "status" },
                                                [
                                                  _c("span", {
                                                    staticClass:
                                                      "profile-image rounded-circle d-inline-block",
                                                    style: {
                                                      "background-image":
                                                        "url(" +
                                                        item.medium_img +
                                                        ")",
                                                      "background-size":
                                                        "cover",
                                                    },
                                                  }),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "ml-3" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "user_attrib",
                                                    },
                                                    [
                                                      _c("div", {
                                                        staticClass:
                                                          "name d-block fw-700 text-dark",
                                                        domProps: {
                                                          textContent: _vm._s(
                                                            item.name
                                                          ),
                                                        },
                                                      }),
                                                      _vm._v(" "),
                                                      _c("div", {
                                                        staticClass:
                                                          "company small text-dark",
                                                        domProps: {
                                                          textContent: _vm._s(
                                                            _vm.user_company(
                                                              item
                                                            )
                                                          ),
                                                        },
                                                      }),
                                                      _vm._v(" "),
                                                      _c("div", {
                                                        staticClass:
                                                          "dolznost small text-dark",
                                                        domProps: {
                                                          textContent: _vm._s(
                                                            item.dolznost
                                                          ),
                                                        },
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "vacation",
                                                        },
                                                        [
                                                          _c("vacation", {
                                                            attrs: {
                                                              id: parseInt(
                                                                item.id
                                                              ),
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "add_adjust" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "add_in_start cursor-pointer bg-warning-500 shadow text-white",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          $event.preventDefault()
                                                          return _vm.set_active(
                                                            item
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                                            Вибрати\n                                                        "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ])
                                  }),
                                  0
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }